import { apiRequest } from './apiClient';

// level is 'states' | 'cities'.
const LEVEL_PATH = { states: '/states', cities: '/cities' };

export const fetchLocations = async () => {
  const [states, cities] = await Promise.all([apiRequest('/states'), apiRequest('/cities')]);
  return { states: states.data, cities: cities.data };
};

export const createLocation = async (level, payload) =>
  (await apiRequest(LEVEL_PATH[level], { method: 'POST', body: JSON.stringify(payload) })).data;

export const updateLocation = async (level, id, payload) =>
  (await apiRequest(`${LEVEL_PATH[level]}/${id}`, { method: 'PATCH', body: JSON.stringify(payload) })).data;

export const deleteLocation = async (level, id) =>
  apiRequest(`${LEVEL_PATH[level]}/${id}`, { method: 'DELETE' });
